import { Box, Button, Typography } from "@mui/material";
import { useNavigate } from "react-router";
import Add from "@mui/icons-material/Add";
import { Link as LinkIcon } from "@mui/icons-material";
import { useState } from "react";
import MultiTabURLImportModal from "../../components/MultiTabURLImportModal";
import { useCustomPermissions } from "../../hooks/usePermissions";

// Map entityKey to resource name for permission checking
const getResourceFromEntityKey = (entityKey?: string): string => {
  const mapping: Record<string, string> = {
    "chat-transfer-cases": "transfer_case",
    "customer-data": "customer_data",
    "context": "context",
    "unanswered-question": "unanswered_question",
    "environ-variables": "environ_variables",
  };
  return mapping[entityKey || ""] || entityKey || "";
};

const NoDataEmpty: React.FC<{ entityKey?: string; agentId?: string }> = ({
  entityKey,
  agentId,
}) => {
  const navigate = useNavigate();
  const [modalOpen, setModalOpen] = useState(false);
  const { hasPermission } = useCustomPermissions();

  const resourceName = getResourceFromEntityKey(entityKey);
  const canCreate = hasPermission(resourceName, 'create');

  const handleURLExtracted = (extractedData: { 
    key: string; 
    value: string; 
    tags: string[] 
  }) => {
    // Redirect to create page with pre-filled data
    const searchParams = new URLSearchParams();
    searchParams.set('key', extractedData.key);
    searchParams.set('value', extractedData.value);
    searchParams.set('tags', JSON.stringify(extractedData.tags));
    
    navigate(`/${entityKey}/${agentId ?? ""}/create?${searchParams.toString()}`);
    setModalOpen(false);
  };  

  return (
    <Box
      width={"100%"}
      display="flex"
      alignItems="center"
      justifyContent="center"
      flexDirection="column"
      height="100vh"
      textAlign="center"
    >
      <Typography variant="h3" gutterBottom>
        No data
      </Typography>
      {canCreate ? (
        <Typography variant="body2" gutterBottom>
          Do you want to add one?
        </Typography>
      ) : (
        <Typography variant="body2" gutterBottom color="text.secondary">
          No data available
        </Typography>
      )}

      {canCreate && (
        <Box sx={{ display: 'flex', gap: 2, mt: 2 }}>
          <Button
            variant="contained"
            onClick={() => navigate(`/${entityKey}/${agentId ?? ""}/create`)}
          >
            <Add fontSize="small" sx={{ mr: 0.5 }} /> Create
          </Button>

          {entityKey === "customer-data" && (
            <Button
              variant="outlined"
              startIcon={<LinkIcon />}
              onClick={() => setModalOpen(true)}
              sx={{
                borderStyle: "dashed",
                "&:hover": {
                  borderStyle: "solid",
                },
              }}
            >
              Import from URL
            </Button>
          )}
        </Box>
      )}

      {entityKey === "customer-data" && (
        <MultiTabURLImportModal
          open={modalOpen}
          onClose={() => setModalOpen(false)}
        />
      )}
    </Box>
  );
};

export default NoDataEmpty;